import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Switch,
  FormControlLabel,
} from "@mui/material";

const EditCountryRateModal = ({
  country,
  handleCountryRateSubmit,
  handleCloseModal,
}) => {
  const serviceName = country?.service?.service_name;

  /* ================= STATE ================= */
  const [formData, setFormData] = useState({
    dlt_rates: country?.dlt_rates || "",
    sms_rates: country?.sms_rates || "",

    authentication_price: country?.authentication_price || "",
    marketing_price: country?.marketing_price || "",
    utility_price: country?.utility_price || "",

    rcs_media_rate: country?.rcs_media_rate || "",
    rcs_text_rate: country?.rcs_text_rate || "",
    show_service: country?.show_service ?? true,
  });
  const handleToggle = async (e) => {
    const newValue = e.target.checked;

    const updatedData = {
      customer_country_id: country.customer_country_id,
      service: country.service,
      ...formData,
      show_service: newValue,
    };

    // UI update immediately
    setFormData((prev) => ({
      ...prev,
      show_service: newValue,
    }));

    try {
      await handleCountryRateSubmit(updatedData); // ✅ SAME API CALL
    } catch (err) {
      console.error(err);
    }
  };
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = () => {
    handleCountryRateSubmit({
      customer_country_id: country.customer_country_id,
      service: country.service, // 🔥 MUST
      ...formData,
    });
  };

  return (
    <Dialog open onClose={handleCloseModal} fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontSize: "1rem", fontWeight: "bold" }}>
        Edit Country Rates ({serviceName})
      </DialogTitle>
      <FormControlLabel sx={{paddingLeft:"10px"}}
        control={
          <Switch
            checked={formData.show_service}
            onChange={handleToggle}
            color="primary"
          />
        }
        label={formData.show_service ? "Active" : "Inactive"}
      />
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={2} mt={1}>
          {/* ================= SMS ================= */}
          {serviceName === "SMS" && (
            <>
              <TextField
                label="DLT Rate"
                name="dlt_rates"
                value={formData.dlt_rates}
                onChange={handleChange}
                type="number"
                size="small"
                disabled={!formData.show_service}
              />
              <TextField
                label="SMS Rate"
                name="sms_rates"
                value={formData.sms_rates}
                onChange={handleChange}
                type="number"
                size="small"
                disabled={!formData.show_service}
              />
            </>
          )}

          {/* ================= WhatsApp ================= */}
          {serviceName === "WhatsApp" && (
            <>
              <TextField
                label="AuthN Price"
                name="authentication_price"
                value={formData.authentication_price}
                onChange={handleChange}
                type="number"
                size="small"
                disabled={!formData.show_service}
              />
              <TextField
                label="Marketing Price"
                name="marketing_price"
                value={formData.marketing_price}
                onChange={handleChange}
                type="number"
                size="small"
                disabled={!formData.show_service}
              />
              <TextField
                label="Utility Price"
                name="utility_price"
                value={formData.utility_price}
                onChange={handleChange}
                type="number"
                size="small"
                disabled={!formData.show_service}
              />
            </>
          )}

          {/* ================= RCS ================= */}
          {serviceName === "RCS" && (
            <>
              <TextField
                label="RCS Media Rate"
                name="rcs_media_rate"
                value={formData.rcs_media_rate}
                onChange={handleChange}
                type="number"
                size="small"
                disabled={!formData.show_service}
              />
              <TextField
                label="RCS Text Rate"
                name="rcs_text_rate"
                value={formData.rcs_text_rate}
                onChange={handleChange}
                type="number"
                size="small"
                disabled={!formData.show_service}
              />
            </>
          )}
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleCloseModal} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained" color="primary">
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditCountryRateModal;
